var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 18,
    viewBox: "0 0 200 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 18,
    fill: "url(#pattern0_2232_9556)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2232_9556",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2232_9556",
    transform: "scale(0.0025 0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2232_9556",
    width: 400,
    height: 36,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAAkCAYAAACnk2wbAAAD20lEQVR4AeycbVIcMQxEQ46dA+TaC71VVDVas0Y7H0iel4qgbUm2/DyggR/8/cO/VgRut9s/t2zxnit9dn52P+LXIqBnzi17Os+VzuYTvy8BGsi+PFkNAhCAwGUILNdA9Fbidpmb5KD9CAwq9mdXehDCFATKEFiugZQhSyEQgAAEFidAAzn5gvVW6Xby9mwHgaUJ+NeW9NKHLXC4xg2kAD1KgAAEIHBhAu0aiN4q3LJ357nSMV9zbll/jM+OfW/p1fJ1Jrd4PvdJR3/1sWp2i/W6Tzr6Z2PluMV490ln/TE+jrWmW9Yf4+PY15aO/t8eqya3WI/7pKN/tXG7BrLaBXAeCHQkQM0QEIFyDURd201FYhCAAAQgUI9AuQZSDxEVQQACEIDAiAANZERlw5z/9CQ9XIrJlwmIqdvLC5E4JOBspYdBTL5MQEzdXl6oSCINpMhFUAYEIACBbgRoIN1ujHoPJeBvh9JxM825RT/j2gRut9umvyV39On82ZI+er+t69NAthIkHwIQgMBFCaQbiLqiW+TmPumsP8YzhkCGgJ45t5jrPunoZ3xtAnom3KrR8NqkY32ac8v6Y/xsnG4gswXxr02A00EAAhD4JPDQQLx7SX8G8hkCEIAABNYmoO/5bvG07pN+aCAxgTEEIAABCFQgUK+Ghwby9vb23y2W7D7prD/GM4YABCAAgXMI6Hu2W9zVfdIz/0MDiQmMIQABCEAAAiMCpzcQdTW3UVHMQeBVAv5sSds6d6k5t/ukfXCftLnuUnNu90k+tCHgdycdC9ecW/QfPfa9peN+mnPL+mP81vHpDWRrweRDAAIQgEANAjSQGvdAFRAoQcDfbqVLFLVQEWLq1v1oP24g3Q9K/RCAAAQgsC+Bcg3Eu7P0vsc9fjXV7Hb8jtfawdlKX+v0nBYCtQiUayC18FANBCoQoAYI1CRAA0nei9563ZLphE8IOFvpSXg5t2p227tAX1s6u75y3LL5xD8n4Gyln0f399JA+t8hJ4AABCDwKwTaNRB1dbcfUPsS4rnSX5wfA825fUzt+t/Xlo6La84t+mdjz5WexUe/ctyifzb2XOkYrzm36F997GeX3vu8WtPt7PV9b+ns/spxOzt/tp/XJj2LX93froGsfiGcDwIQgEAXAjSQLjdFnRDoSICalyZAA1n6ejkcBCAAgeMILNdA9HtJt+PQsTIE9ifgz670/jv0XlFM3Hqfpn/1yzWQ/lfiJ0BDAAIQqEuABlL3boaV+duX9DDoyaRy3J6EDl2eKz0MYhIC3xDQM+P2TRjTTQjQQJpcFGVCAALnEmC3OYF3AAAA///NrzpWAAAABklEQVQDAMfAIHbgtds6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.a087720d4d8d7cbab40a94a2fddabc79.svg";
export { ForwardRef as ReactComponent };